// Import necessary functions from the Interactivity API
import { store, getContext } from '@wordpress/interactivity'

// Define the shape of the server-provided state
type ServerState = {
  state: {
    isOpen: boolean
  }
}

// Define the shape of the context
type Context = {
  isOpen: boolean
}

// Define the store with actions and callbacks
const storeDef = {
  state: {
    isOpen: false,
  },
  actions: {
    toggleOpen() {
      // Access the current context
      const context = getContext<Context>()
      if (!context) {
        console.error('getContext() returned undefined!')
        return
      }
      // Toggle the isOpen state
      context.isOpen = !context.isOpen
      console.log(`Modal is now ${context.isOpen ? 'open' : 'closed'}.`)
    },
  },
  callbacks: {
    logIsOpen: () => {
      // Access the current context
      const context = getContext<Context>()
      // Log the current value of isOpen
      console.log(`Modal is now ${context.isOpen ? 'open' : 'closed'}.`)
    },
  },
}

// Combine the server state type with the store definition
type Store = ServerState & typeof storeDef

// Create the store
export const modalStore = store<Store>('vebbit-blocks-modal', storeDef)
